import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";

import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { ThemeProvider, useTheme } from "@mui/material/styles";
import PersonIcon from "@mui/icons-material/Person";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import AuthService from "../../service/auth";
import { showToast } from "../../store/actions";
import { regexEmail } from "../../util/regularExpress";

function ForgotPassword() {
  const theme = useTheme();
  const dispatch = useDispatch();

  const [emailId, setEmailId] = useState("");
  const [loading, setLoading] = useState(false);

  const [errors, setErrors] = useState({
    email: false,
  });

  const handleLoginIdChange = (e) => {
    let { value } = e.target;
    setEmailId(value);
  };

  const handleSendLink = async (e) => {
    e.preventDefault();
    
    setErrors((prevState) => {
      return {
        ...prevState,
        email: emailId.trim().length > 100 || !regexEmail(emailId.trim())
      };
    });

    if (
      !(
        emailId.trim().length > 100 || 
        !regexEmail(emailId.trim())
      )
    ) {
      setLoading(true);

      const authService = new AuthService();
      const response = await authService.forgotPassword(emailId);

      if (response.success) {
        dispatch(
          showToast({
            type: "success",
            message: response.message,
          })
        );
      }

      setEmailId("");
      setLoading(false);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Backdrop sx={{ color: "red", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="primary" />
      </Backdrop>
      <Box
        className="forgot-pass-page"
        component="main"
        sx={{
          background: (theme) => {
            return theme.palette.TiffanyBlue.gradient;
          },
          flexGrow: 1,
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Container component="main" maxWidth="sm">
          <CssBaseline />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              overflowY: "auto",
            }}
          >
            <Box
              component="form"
              noValidate
              sx={{ width: "80%" }}
              style={{ background: "#fff", padding: "25px", borderRadius: "10px" }}
            >
              <Typography style={{ fontSize: "28px", fontWeight: "bold", textAlign: "center" }}>
                Enter your Email ID
              </Typography>

              <TextField
                margin="normal"
                required
                fullWidth
                label="Email ID"
                autoFocus
                value={emailId}
                onChange={handleLoginIdChange}
                error={errors.email}
                helperText={errors.email ? "Please enter an valid email." : ""}
                InputProps={{
                  endAdornment: <PersonIcon color="primary" />,
                }}
              />
              {/* Change to Smallcase */}
              <Button
                className="btn btn-primary"
                color="secondary"
                onClick={handleSendLink}
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                Send reset link
              </Button>
              <Link
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  fontSize: "15px",
                  textDecoration: "none",
                  color: "#514efd",
                }}
                to="/"
              >
                <ArrowBackIcon fontSize="small" />
                Back to login
              </Link>
            </Box>
          </Box>
        </Container>
      </Box>
    </ThemeProvider>
  );
}

export default ForgotPassword;
